import React from 'react';
import * as consts from '../../../models/consts.js'
import QueryStringService from '../../../services/queryStringService.js';
import CampaignSummaryPlayLocalParam5 from './CampaignSummaryPlayLocalParam5.jsx';
import CampaignDetailsPlayLocalParam5 from './CampaignDetailsPlayLocalParam5.jsx';
import PanelService from '../../../services/panelService.js';

export default class CampaignInfoPlayLocalParam5 extends React.Component {
    constructor() {
        super();
        this.queryStringService = new QueryStringService();
        this.country = this.queryStringService.getCurrentCountry();
        this.state = {
        };
    }

    shouldShow() {
        return Array.from(arguments).includes(this.country);
    }

    validateOrderlineAgainstExceptionList(orderline) {
        if (this.props.orderData.orderlinesExceptionsForce5SecVacValues) {
            if (this.props.orderData.orderlinesExceptionsForce5SecVacValues.includes(parseInt(orderline))) {
                return true
            }
            if (this.props.orderData.orderlinesExceptionsForce5SecVacValues.includes(orderline)) {
                return true
            }
        }
        return false
    }

    render() {
        let selectedDetailsData = this.props.selectedDetailsData
        let spotlength = '';
        if (this.props.selectedDetailsData.spotlengths){
            if (this.props.selectedDetailsData.spotlengths.length > 1){
                spotlength = 'mixed'
            }
            else if (this.props.selectedDetailsData.spotlengths.length > 0){
                spotlength = this.props.selectedDetailsData.spotlengths[0];
            }
        }
        let extraValueLabel = ''
        let extraValueValue = 0

        return (
            <div className="row campaign-info">
                <div className="col-sm-6 col-sm-push-6 col-md-6 col-md-push-6 campaign-summary-container" align="center">
                    <CampaignSummaryPlayLocalParam5
                        selectedCampaignType={this.props.selectedCampaignType}
                        dataFetchedInUTC={this.props.orderData.dataFetchedInUTC}
                        campaignName={this.props.campaignName}
                        selectedData={this.props.selectedData}
                        selectedDataType={this.props.selectedDataType}
                        onSelectDataType={(dataType) => this.props.onSelectDataType(dataType)}
                        campaignInfo={this.props.campaignInfo}
                        contactsLabel={this.props.contactsLabel}
                        parameters={this.props.parameters}
                        spotlength={spotlength}
                        campaignPackagePromise={this.props.campaignPackagePromise}
                        selectedOrderLines={this.props.selectedOrderLines}
                        extraValueValue={extraValueValue}
                        useAlternateContacts={this.props.useAlternateContacts}
                        />
                </div>
                <div className="col-sm-6 col-sm-pull-6 col-md-pull-6 col-md-6" style={{'paddingBottom': '20px'}}>
                    <CampaignDetailsPlayLocalParam5
                        campaignInfo={this.props.campaignInfo}
                        orderData={this.props.orderData}
                        campaignName={this.props.campaignName}
                        periodManuallySelected={this.props.periodManuallySelected}
                        selectedCampaignType={this.props.selectedCampaignType}
                        selectedData={this.props.selectedData}
                        selectedDataType={this.props.selectedDataType}
                        selectedDetailsData={selectedDetailsData}
                        parameters={this.props.parameters}
                        spotlength={spotlength}
                        selectedOrderLines={this.props.selectedOrderLines}
                        campaignPackagePromise={this.props.campaignPackagePromise}
                        extraValueValue={extraValueValue}
                        extraValueLabel={extraValueLabel}
                        useAlternateContacts={this.props.useAlternateContacts}/>
                </div>
            </div>
        );
    }
}